// License Hub 안쪽 탭 (법인 관리 · 발급 현황 · 발급현황(Self) 공용).
// 모든 탭 내용을 마운트한 채 비활성 쪽만 d-none 으로 숨겨, 탭을 오가도 필터·쪽 상태와 조회가 유지된다.
// tabs: [{ key, label, content }] — 첫 항목이 기본 탭.
import React, { useState } from 'react';

// onChange(activeKey): 선택 — 탭이 바뀔 때마다 새 key 로 호출(부모가 현재 탭을 알아야 할 때).
const LicenseListTabs = ({ tabs, onChange }) => {
    const list = Array.isArray(tabs) ? tabs : [];
    const [active, setActive] = useState(list[0]?.key);

    const select = (key) => {
        setActive(key);
        if (typeof onChange === 'function') onChange(key);
    };

    return (
        <>
            {/* 앱 다른 화면(예: /MySearch)의 탭과 같은 style2 — 둥근 알약 + 칸 둘레 여백. */}
            <ul className="nav nav-tabs style2 license-list-tabs mt-1 mb-2" role="tablist">
                {list.map((x) => (
                    <li className="nav-item" key={x.key} role="presentation">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={active === x.key}
                            className={active === x.key ? 'nav-link active' : 'nav-link'}
                            onClick={() => select(x.key)}
                        >
                            {x.label}
                        </button>
                    </li>
                ))}
            </ul>
            {list.map((x) => (
                <div key={x.key} role="tabpanel" className={active === x.key ? undefined : 'd-none'}>
                    {x.content}
                </div>
            ))}
        </>
    );
};

export default LicenseListTabs;
